var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg074Message(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 56 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "-11.388%",
    x2: "111.388%",
    y1: "10.617%",
    y2: "89.381%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3d6d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f6d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#f6d8da"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "073---Mobile-Text",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 4v47c0 1.6568542-1.3431458 3-3 3h-28c-1.65685425 0-3-1.3431458-3-3v-47c0-1.65685425 1.34314575-3 3-3h4l2.86 3.05c.5663757.60708315 1.3597411.95123705 2.19.95h9.9c.8302589.00123705 1.6236243-.34291685 2.19-.95l2.86-3.05h4c1.6568542 0 3 1.34314575 3 3z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32 1h-3c1.6568542 0 3 1.34314575 3 3v47c0 1.6568542-1.3431458 3-3 3h3c1.6568542 0 3-1.3431458 3-3v-47c0-1.65685425-1.3431458-3-3-3z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 51v5c0 1.6568542-1.3431458 3-3 3h-28c-1.65685425 0-3-1.3431458-3-3v-5c0 1.6568542 1.34314575 3 3 3h28c1.6568542 0 3-1.3431458 3-3z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32 54v2c0 1.6568542-1.3431458 3-3 3h3c1.6568542 0 3-1.3431458 3-3v-5c0 1.6568542-1.3431458 3-3 3z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28 1-2.86 3.05c-.5663757.60708315-1.3597411.95123705-2.19.95h-9.9c-.8302589.00123705-1.6236243-.34291685-2.19-.95l-2.86-3.05z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m25 1-2.86 3.05c-.5663757.60708315-1.3597411.95123705-2.19.95000332l3-.00000332c.8302589.00123705 1.6236243-.34291685 2.19-.95l2.86-3.05z",
    fill: "#ff9ea1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29.626 43.1c-3.182 2.563-7.541 2.957-10.216 2.916-.3917561-.0064893-.743152-.2425075-.8973371-.6027046s-.0823905-.7773652.1833371-1.0652954c1.0938944-1.3279413 1.8470339-2.9028747 2.194-4.588.1661215-.7044162-.0682116-1.4431417-.61-1.923-3.2639911-2.6632957-5.1942986-6.6251789-5.28-10.837 0-8.84 8.95-16 20-16s20 7.16 20 16-8.95 16-20 16c-1.2666878-.0001811-2.531575-.0954488-3.784-.285-.5605287-.099982-1.137297.0396758-1.59.385z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 11c-.506 0-1 .031-1.5.061 10.346.615 18.5 7.504 18.5 15.939s-8.177 15.343-18.544 15.941c.511.032 1.023.059 1.544.059 11.05 0 20-7.16 20-16s-8.95-16-20-16z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28.216 42.715c-.5599644-.1011102-1.1366743.0370825-1.59.381-2.227474 1.6478502-4.8821127 2.6198638-7.647 2.8.1330237.0702865.2805867.1086323.431.112 2.674.041 7.034-.353 10.216-2.916.0934976-.0722049.1940005-.1348516.3-.187-.577-.043-1.149-.105-1.71-.19z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 35,
    cy: 27,
    fill: "#ffe7e8",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 27,
    cy: 27,
    fill: "#ffe7e8",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 27,
    fill: "#ffe7e8",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m1 4v52c0 1.6568542 1.34314575 3 3 3h3c-1.65685425 0-3-1.3431458-3-3v-52c0-1.65685425 1.34314575-3 3-3h-3c-1.65685425 0-3 1.34314575-3 3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m0 36h2v8h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff414c"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 40,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4 0c-2.209139 0-4 1.790861-4 4v32c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-32c0-1.1045695.8954305-2 2-2h3.567l2.564 2.735c.7571716.80580401 1.8132755 1.26348524 2.919 1.265h9.9c1.1057245-.00151476 2.1618284-.45919599 2.919-1.265l2.564-2.735h3.567c1.1045695 0 2 .8954305 2 2v6.041c-11.114.427-20 7.859-20 16.959.0838817 4.5006815 2.1401083 8.7374442 5.624 11.588.2615723.238271.373356.5996537.292.944-.3096388 1.5271159-.9887768 2.955091-1.978 4.159-.5219683.5934427-.6490323 1.4371476-.325 2.158.315386.7052701 1.0144311 1.1606079 1.787 1.164h.379c3.09 0 7.288-.57 10.479-3.142.2366299-.164817.5300246-.2265273.813-.171 1.3003222.1981087 2.6136741.2983901 3.929.3 11.58 0 21-7.626 21-17 0-9.1-8.886-16.532-20-16.959v-6.041c0-2.209139-1.790861-4-4-4zm50 27c0 8.271-8.523 15-19 15-1.2164437-.0003211-2.4311615-.0915754-3.634-.273-.8363587-.1438969-1.6947183.0697861-2.366.589-3.011 2.426-7.289 2.73-9.545 2.68 1.2018051-1.4505434 2.0299435-3.1734284 2.412-5.018.2496596-1.0644461-.1084028-2.1797853-.931-2.9-3.04308-2.4733722-4.8475064-6.1575312-4.936-10.078 0-8.271 8.523-15 19-15s19 6.729 19 15zm-28.308-25-1.282 1.368c-.378896.40269492-.907076.63133176-1.46.632h-9.9c-.5527743.00000995-1.0809024-.22876112-1.459-.632l-1.282-1.368z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36 56v-9c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v4c0 1.1045695-.8954305 2-2 2h-28c-1.1045695 0-2-.8954305-2-2v-7c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1v12c0 2.209139 1.790861 4 4 4h28c2.209139 0 4-1.790861 4-4zm-4 2h-28c-1.1045695 0-2-.8954305-2-2v-1.556c.60534654.3599241 1.29574677.5518554 2 .556h28c.7042532-.0041446 1.3946535-.1960759 2-.556v1.556c0 1.1045695-.8954305 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43.512 17.956c4.063 2.07 6.488 5.451 6.488 9.044 0 .5522847.4477153 1 1 1s1-.4477153 1-1c0-4.36-2.833-8.407-7.58-10.825-.3195472-.1751414-.7090678-.1625992-1.016686.0327363-.3076182.1953356-.4846313.5425386-.4620211.9062332.0226101.3636945.2412638.6862997.5707071.8420305z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m5 11c.55228475 0 1-.4477153 1-1v-2c0-.55228475-.44771525-1-1-1s-1 .44771525-1 1v2c0 .5522847.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4 30c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-16c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32 27c0 1.6568542 1.3431458 3 3 3s3-1.3431458 3-3-1.3431458-3-3-3-3 1.3431458-3 3zm4 0c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1 .4477153-1 1-1 1 .4477153 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 24c-1.6568542 0-3 1.3431458-3 3s1.3431458 3 3 3 3-1.3431458 3-3-1.3431458-3-3-3zm0 4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1 1 .4477153 1 1-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43 30c1.6568542 0 3-1.3431458 3-3s-1.3431458-3-3-3-3 1.3431458-3 3 1.3431458 3 3 3zm0-4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1-1-.4477153-1-1 .4477153-1 1-1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg074Message);
export default __webpack_public_path__ + "static/media/074-message.8cd235ec1c43b6301810c30a3c7e46b5.svg";
export { ForwardRef as ReactComponent };